import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Fetcher } from '@garpix/fetcher/fetcher/storeon'
import { PageModelType } from '@/api/interfaces/Page'
import { dataStates } from '@garpix/fetcher'
import Home from './Home'
import GameDetail from './GameDetail'
import NewsPage from './News'
import AuthorizationPage from './Authorization'
import PageSpinner from '@/components/Spinner/PageSpinner'
import GamesPage from './Games'
import CabinetProfile from './CabinetProfile'
import CabinetChampionshipsPage from './CabinetChampionships'
import CabinetCertificatesPage from './CabinetCertificates'
import ResetPasswordPage from './ResetPassword'
import LeadersContactsPage from './LeadersContacts'
import MediaDetailPage from './MediaDetail'
import RestorePasswordSetPassword from './RestorePasswordSetPassword'
import NewsDetailPage from './NewsDetail'
import ChampionshipsPage from './Championships'
import ChampionshipApplicationPage from './ChampionshipApplication'
import ChampionshipDetailPage from './ChampionshipDetail'
import TournamentsPage from './Tournaments'
import Page404 from './Page404'
import TournamentsDetailPage from './TournamentsDetail'
import LiveLikeAHostPage from './LiveLikeAHost'
import EducationPage from './Education'
import BestInProfessionPage from './BestInProfession'
import RecommendToKnowPage from './RecommendToKnow'
import QuizPage from './Quiz'
import InstitutionDetailPage from './InstitutionDetail'
import CabinetContestsPage from './CabinetContests'
import ContestDetailPage from './ContestDetail'
import AddWorkPage from './AddWork'
import UrbanClubPage from './UrbanClub'
import LecturePage from './Lecture'
import SuccessStoryDetailPage from './SuccessStoryDetail'
import LessonPage from './Lesson'
import PrivacyPolicyPage from './PrivacyPolicy'
import ProfessionCompetitionPage from './ProfessionCompetition'
import WhatToReadDetailPage from './WhatToReadDetail'

const PAGE_TYPES: { [key in PageModelType]: React.FC } = {
  Page: Home,
  home_page: Home,
  detail_game: GameDetail,
  authorization: AuthorizationPage,
  games: GamesPage,
  news: NewsPage,
  news_detail: NewsDetailPage,
  profile: CabinetProfile,
  cabinet_championships: CabinetChampionshipsPage,
  cabinet_contests: CabinetContestsPage,
  cabinet_certificates: CabinetCertificatesPage,
  forgot_your_password: ResetPasswordPage,
  restore_password_set_password: RestorePasswordSetPassword,
  leaders_contacts: LeadersContactsPage,
  media_detail: MediaDetailPage,
  championships: ChampionshipsPage,
  championship_application: ChampionshipApplicationPage,
  championship_detail: ChampionshipDetailPage,
  tournaments: TournamentsPage,
  tournaments_detail: TournamentsDetailPage,
  live_like_a_host: LiveLikeAHostPage,
  education: EducationPage,
  best_in_profession: BestInProfessionPage,
  recommend_to_know: RecommendToKnowPage,
  institution_detail: InstitutionDetailPage,
  contest_detail: ContestDetailPage,
  quiz: QuizPage,
  add_work: AddWorkPage,
  urban_club: UrbanClubPage,
  lecture: LecturePage, // Лекции клуба урбанистов
  success_story: SuccessStoryDetailPage,
  lesson: LessonPage, // Уроки со слайдера страницы рекомендуем знать
  privacy_policy: PrivacyPolicyPage,
  personal_data_policy: PrivacyPolicyPage,
  profession_competition: ProfessionCompetitionPage,
  what_read: WhatToReadDetailPage,
  500: NewsPage,
  404: Page404
}

const Combine = (props): React.ReactElement => {
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const match = {
    params
  }
  return (
    <Fetcher
      match={match}
      navigate={navigate}
      location={location}
      paramsKey='*'
      {...props}
    >
      {(data = {} as any, _, status) => {
        const pageType = data?.pageType
        const page = data?.page
        if (pageType === undefined) {
          return null
        }
        const Page = PAGE_TYPES[pageType]
        if (status === dataStates.loading) {
          return <PageSpinner />
        }
        return <Page {...page} />
      }}
    </Fetcher>
  )
}

export default Combine
